import { render, staticRenderFns } from "./ClassesStats.vue?vue&type=template&id=43a06030&"
import script from "./ClassesStats.vue?vue&type=script&lang=js&"
export * from "./ClassesStats.vue?vue&type=script&lang=js&"
import style0 from "./ClassesStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports